<template>
  <div>
    <v-dialog v-model="showDialog" max-width="800px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('manage_bot_profile') }}</span>
        </v-card-title>
        <v-card-text>
          <div class="py-2">
            {{ $t('avatar') }}
            <uploadfile v-model="input.profile_pic" :height="80"></uploadfile>
            <input
              v-model="input.profile_pic"
              v-validate="'required'"
              type="hidden"
              name="avatar"
              :data-vv-as="$t('avatar')"
            />
            <span v-show="errors.has('avatar')" class="caption error--text">{{
              errors.first('avatar')
            }}</span>
          </div>
          <div class="py-2">
            <v-text-field
              v-model="input.name"
              v-validate="'required'"
              :label="$t('name')"
              required
              name="name"
              outline
              errors
              :hide-details="!errors.has('name')"
              :error="errors.has('name')"
              :error-messages="errors.first('name')"
              maxlength="155"
            ></v-text-field>
          </div>
          <div class="py-2">
            <toggle-button
              :value="input.is_active"
              :sync="true"
              :color="$vuetify.theme.success"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
              style="display: inline-block"
              @change="handleChangeIsActive()"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" outline @click="showDialog = false">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="primary" @click="handleSubmit()">
            {{ $t('Save') }}
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import uploadfile from '@/components/elements/uploadfile'
import { ToggleButton } from 'vue-js-toggle-button'
import botProfileApi from '@/api/bot-profile/bot-profile.js'
export default {
  components: { uploadfile, ToggleButton },
  props: ['value', 'profile'],
  data() {
    return {
      showDialog: this.value,
      input: {
        name: '',
        profile_pic: '',
        is_active: true
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    value() {
      this.showDialog = this.value
      if (this.value) {
        if (this.profile) {
          this.input = {
            name: this.profile.name,
            profile_pic: this.profile.profile_pic,
            is_active: this.profile.is_active
          }
        } else {
          this.input = {
            name: '',
            profile_pic: '',
            is_active: true
          }
        }
      }
    },
    showDialog() {
      this.$emit('input', this.showDialog)
    }
  },
  methods: {
    handleChangeIsActive() {
      this.input.is_active = !this.input.is_active
    },
    async handleSubmit() {
      const result = await this.$validator.validateAll()
      if (!result) {
        this.goToErrorInput()
        return false
      }

      let promiseApi = null

      if (this.profile && this.profile.id) {
        promiseApi = botProfileApi.putBotProfile({
          data: {
            id: this.profile.id,
            name: this.input.name,
            profile_pic: this.input.profile_pic,
            is_active: this.input.is_active,
            page_id: this.selectedBot.pageid
          }
        })
      } else {
        promiseApi = botProfileApi.postBotProfile({
          data: {
            name: this.input.name,
            profile_pic: this.input.profile_pic,
            is_active: this.input.is_active,
            page_id: this.selectedBot.pageid
          }
        })
      }

      if (promiseApi) {
        const response = await promiseApi
        if (response.status == 200 || response.status == 204) {
          this.$store.dispatch('loadBotProfile')
          this.$swal({
            title: this.$t('Save successful'),
            type: 'success',
            confirmButtonText: this.$t('Confirm'),
            reverseButtons: true
          })
          this.showDialog = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/BotProfile/DialogManageBotProfile.vue